import { render, staticRenderFns } from "./StandardOrderStatistics.vue?vue&type=template&id=29281ac2&"
import script from "./StandardOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./StandardOrderStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports